import {
  PackageThumbnail,
  ListeningPackageType,
  PriceDetails,
  StudentPlanStatus
} from '../../../common/services/package/package.model';
import PriceService from '../../../common/services/price.service';
import GoogleAnalyticsService from '../../../common/services/analytics/google-analytics.service';
import { AddCartEvent, Ecommerce, Product, ProductClickEvent } from '../../../common/services/analytics/events/dimensions';
import PackageService from '../../../common/services/package/package.service';
import angular = require('angular');
import { OpenYearlyContractedAction } from '../../../buy/yearly-contracted-info/yearly-contracted-dialog.action';
import { OpenYearlyAction } from '../../../buy/yearly-info/yearly-dialog.action';
import ActionDispatcherService from '../../../common/actions/core/action-dispatcher.service';
import StudentPlanService from '../../../common/services/package/student.service';
import { OpenStudentNoSubAction } from '../../../components/student/nosub/nosub.action';
import { OpenStudentReviewingAction } from "../../../components/student/reviewing/reviewing.action";
import { OpenStudentRejectedAction } from "../../../components/student/rejected/rejected.action";
import { OpenStudentSuccessfulAction } from "../../../components/student/successful/successful.action";
import { OpenStudentBlockedAction } from '../../../components/student/blocked/blocked.action';
import { OpenStudentLimitAction } from '../../../components/student/limit-exceeded/limit-exceeded.action';
import { OpenStudentQuotaAction } from '../../../components/student/quota-exceeded/quota-exceeded.action';

/* @ngInject */
export default class PacketController {
  private packet: PackageThumbnail;
  private ecommerce: Ecommerce = new Ecommerce();

  public storePackage: boolean;
  public priceDetails: PriceDetails;
  public description: string;
  public description2: string;
  public time: string;

  constructor(
    private $state,
    private priceService: PriceService,
    private googleAnalytics: GoogleAnalyticsService,
    private packageService: PackageService,
    private actionDispatcher: ActionDispatcherService,
    private studentPlanService: StudentPlanService
  ) {
  }

  public $onInit() {
    this.time = this.priceService.getPriceInfo(this.packet);

    this.storePackage =
      this.packet &&
      this.packet.type &&
      (this.packet.type === ListeningPackageType.GOOGLEPLAY ||
        this.packet.type === ListeningPackageType.APPLESTORE);
  }

  public getDescContent() {
    return this.packet.descContent || this.packet.description;
  }

  public startSubscription() {
    if (localStorage.getItem("userHasYearlyContracted")) {
      this.actionDispatcher.dispatch(
        new OpenYearlyContractedAction(() => this.checkStudentPopup())
      );
    } else if (localStorage.getItem("userHasYearly")) {
      this.actionDispatcher.dispatch(
        new OpenYearlyAction(() => this.checkStudentPopup())
      );
    } else {
      this.checkStudentPopup();
    }
  }

  private checkStudentPopup() {
    if (!this.packet.isStudent) {
      this.goToSubscriptionPage();
    } else {
      this.studentPlanService.getUserStudentStatus().then(data => {
        switch (data.studentPlanStatus) {
          case StudentPlanStatus.APPROVED:
            this.actionDispatcher.dispatch(
              new OpenStudentSuccessfulAction(this.packet.id, data.expireDate)
            );
            break;
          case StudentPlanStatus.PENDING:
            // pending page
            this.actionDispatcher.dispatch(
              new OpenStudentReviewingAction()
            );
            break;
          case StudentPlanStatus.REJECTED:
            // rejcted
            this.actionDispatcher.dispatch(
              new OpenStudentRejectedAction()
            );
            break;
          case StudentPlanStatus.NOT_APPLIED:
            // apply form
            // after success aplication received form
            this.actionDispatcher.dispatch(
              new OpenStudentNoSubAction()
            );
            break;
          case StudentPlanStatus.BLOCKED:
            this.actionDispatcher.dispatch(
              new OpenStudentBlockedAction()
            );
            break;
          case StudentPlanStatus.LIMIT_EXCEEDED:
            this.actionDispatcher.dispatch(
              new OpenStudentLimitAction()
            );
            break;
          case StudentPlanStatus.QUOTA_EXCEEDED:
            this.actionDispatcher.dispatch(
              new OpenStudentQuotaAction()
            );
            break;
          default:
            this.actionDispatcher.dispatch(
              new OpenStudentNoSubAction()
            );
            break;
        }
      }).catch(error => { })
    }
  }

  private goToSubscriptionPage() {
    this.ecommerce = this.googleAnalytics.setEcommerce(this.packet, 'Add to Card', 'Satın Alabileceğim Üyelikler');
    this.googleAnalytics.trackEvent(angular.extend(JSON.parse(JSON.stringify(new AddCartEvent)), { ecommerce: this.ecommerce, userPackage: localStorage.getItem('activePackages') }));

    this.ecommerce = this.googleAnalytics.setEcommerce(this.packet, 'Click', 'Satın Alabileceğim Üyelikler');
    this.googleAnalytics.trackEvent(angular.extend(JSON.parse(JSON.stringify(new ProductClickEvent)), { ecommerce: this.ecommerce, userPackage: localStorage.getItem('activePackages') }));

    this.goToBuy();
  }

  private goToBuy() {
    this.$state.go('noAuthBuy', { packetId: this.packet.id });
  }

  public getIcon() {
    return this.packageService.getPackageIcon(this.packet);
  }
}



// WEBPACK FOOTER //
// ./src/app/no-auth/components/packet/packet.controller.ts